import { Router } from "express";

import { authController } from "../controllers/auth-controller";
import { validationController } from "../controllers/validation-controller";
import { createRateLimit } from "../middleware/auth-middleware";

const router = Router();

// Environment-aware rate limiting configurations
// Development: No limits (disabled) | Production: Higher limits
const validationRateLimit = createRateLimit.validation(); // 100 req/5min (prod) | unlimited (dev)
const otpRateLimit = createRateLimit.otp(); // 10 req/10min (prod) | unlimited (dev)

/**
 * @route   GET /api/v1/validate/email
 * @desc    Check if email is available for registration
 * @access  Public
 * @query   { email }
 */
router.get("/email", validationRateLimit, (req, res) =>
  authController.checkEmailAvailability(req, res),
);

/**
 * @route   POST /api/v1/validate/resend-otp
 * @desc    Resend OTP for email verification or password reset
 * @access  Public
 * @body    { email, type }
 */
router.post("/resend-otp", otpRateLimit, (req, res) =>
  authController.resendOTP(req, res),
);

/**
 * @route   GET /api/v1/validate/school-id
 * @desc    Check if school ID is valid and active
 * @access  Public
 * @query   { schoolId }
 */
router.get("/school-id", validationRateLimit, (req, res) =>
  validationController.checkSchoolCode(req, res),
);

/**
 * @route   GET /api/v1/health
 * @desc    Health check endpoint
 * @access  Public
 */
router.get("/health", (req, res) => {
  validationController.healthCheck(req, res);
});

/**
 * @route   GET /api/v1/version
 * @desc    Get API version information
 * @access  Public
 */
router.get("/version", (req, res) => {
  validationController.getVersion(req, res);
});

export default router;
